import { Dispatch, SetStateAction, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { v7 as uuidv7 } from "uuid";

import { TABLE_NAMES } from "../../../../shared";
import ResourceTag from "../../../../shared/components/tags/ResourceTag";
import SelectedRowsTag from "../../../../shared/components/tags/SelectedRowsTag";
import BannerMessage, {
  BANNER_MESSAGE_STATUSES
} from "../../../BannerMessage/BannerMessage";
import useCompaniesResources from "../../hooks/useCompaniesResources";
import { getPayloadObject } from "../functions";

interface IDeleteTableItemsDialogContentProps {
  selectedRows: string[];
  setPayload: Dispatch<SetStateAction<object | null>>;
  resourceName: TABLE_NAMES | undefined;
}

const DeleteTableItemsDialogContent = ({
  selectedRows,
  setPayload,
  resourceName
}: IDeleteTableItemsDialogContentProps) => {
  const { companyRelatedResources, isLoading } = useCompaniesResources(
    resourceName,
    selectedRows
  );
  const { t } = useTranslation();

  const resourceCount = selectedRows?.length;

  useEffect(() => {
    setPayload(getPayloadObject(resourceName, selectedRows));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows, setPayload]);

  const generateCompaniesRelatedResourcesTags = () => {
    if (companyRelatedResources) {
      return Object.entries(companyRelatedResources).map(([key, val]) => (
        <ResourceTag
          key={uuidv7()}
          resource={key}
          isLoading={isLoading}
          count={val}
        />
      ));
    }
  };

  return (
    <>
      {resourceName === TABLE_NAMES.Companies && (
        <BannerMessage
          data-testid="delete-companies-dialog-banner"
          status={BANNER_MESSAGE_STATUSES.Warning}
          title={t("Dialog##delete companies warning")}
          externalCustomStyle={{ marginBottom: "16px" }}
        />
      )}
      <SelectedRowsTag
        resourceName={resourceName}
        resourceCount={resourceCount}
      />
      {generateCompaniesRelatedResourcesTags()}
    </>
  );
};

export default DeleteTableItemsDialogContent;
